import React from 'react';

export interface SignalInfoProps {
  size?: number;
}

export const SignalInfo: React.FC<SignalInfoProps> = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.99935 11.3332C8.94487 11.3332 11.3327 8.94536 11.3327 5.99984C11.3327 3.05432 8.94487 0.666504 5.99935 0.666504C3.05383 0.666504 0.666016 3.05432 0.666016 5.99984C0.666016 8.94536 3.05383 11.3332 5.99935 11.3332ZM5.16602 6.00224L5.16602 8.99984H6.83268L6.83268 6.00224H5.16602ZM4.99935 3.99984C4.99935 3.44755 5.44706 2.99984 5.99935 2.99984C6.55163 2.99984 6.99935 3.44755 6.99935 3.99984C6.99935 4.55212 6.55163 4.99984 5.99935 4.99984C5.44706 4.99984 4.99935 4.55212 4.99935 3.99984Z"
      fill="#261B36"
    />
  </svg>
);
